<template>
<td v-if="!dataItem.inEdit" :class="className">{{ dataItem[field]}}</td>
    <td v-else><dropdownlist @change="change" :data-items='sifrantData' :text-field="'naziv'" :class="customClass" :value="selectedValue" ></dropdownlist></td>
</template>
<script>
import { DropDownList } from '@progress/kendo-vue-dropdowns';


export default {
      components: {
  'drodownlist': DropDownList,

    },
    props: {

        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sifrantData:Array, 
        selectedValue:Object,
        customClass:String

           },
    
    watch: {
    "dataItem": function (newVal,oldVal) {
      console.log("Change of sifrant!!!")
    //  this.selectedValue=this.sifrantData.find(i=>i.id==newVal);//{id:val.statuspridelkaid,naziv:val.statuspridelkanaziv};
    }
    },

    methods: {
        change(e) {
             this.$emit('change', e, this.dataItem, e.value);
        }
    }
}
</script>